const toAbbreviation = (str) => {
  const firstLetter = str.slice(0, 1);
  const bigLetters = str.match(/[A-Z]/g)?.join('');
  return `${firstLetter}${bigLetters || ''}`.toLowerCase();
};

const toShorthandSpacing = (str) => str.replace('spacing', 's');

const generateClassModifiers = (initialClass, modifier, breakpoint) =>
  Object.keys(modifier).map(
    (key) =>
      `${initialClass}--${breakpoint ? `bp-${breakpoint}-` : ''}${toAbbreviation(key)}${
        modifier[key] ? `-${toShorthandSpacing(modifier[key])}` : ''
      }`
  );

export default generateClassModifiers;
